/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForWorkload extends models.BaseReportConfigurationForAssessmentAgent {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForWorkload");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForWorkload.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForWorkload>): ReportConfigurationForWorkload {
        let obj = Object.assign(new ReportConfigurationForWorkload(), model);
        ReportConfigurationForWorkload.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForWorkload>): ReportConfigurationForWorkload {
        if (!model) return null;
        return ReportConfigurationForWorkload.newInstance(<ReportConfigurationForWorkload> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForWorkload) {
        if (!obj) return;

        models.ReportConfigurationForWorkload.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForWorkload): boolean {
        if (models.BaseReportConfigurationForAssessmentAgent.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForWorkload.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
